import ModalResultsAnalysis from "./ModalResultsAnalysis";

export default ModalResultsAnalysis;